export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Se connecter",
    "login.form.hint.user": "Identifiant",
    "login.form.hint.password": "Mot de passe",
    "login.form.checkbox.remember-me": "Mémoriser mes informations",
    "login.form.button.sign-in": "Se connecter",
    "login.form.message.invalid-user-credentials": "Le mot de passe ou l'identifiant est incorrect",
    "login.form.message.account-temporarily-locked": "Votre compte est temporairement verrouillé ; revenez dans 5 minutes",
    "login.form.message.user-required": "Saisir un identifiant",
    "login.form.message.password-required": "Saisir un mot de passe",
    "login.form.button.forgot-password": "Mot de passe oublié ?",
    "error.mfa-required.title": "Configurer l’authentification à deux facteurs",
    "error.mfa-required.message1": "L’authentification à deux facteurs (2FA) est requise pour protéger votre compte.",
    "error.mfa-required.message2": "Vous serez redirigé vers les paramètres de votre compte dans le tableau de bord en ligne. Activez l’authentification à deux facteurs, suivez les instructions de configuration, puis revenez ici.",
    "error.mfa-required.learnMore": "En savoir plus sur l’authentification à deux facteurs",
    "error.mfa-required.continue": "Continuer",
    "error.root-admin-login.title": "Erreur 403 : action interdite",
    "error.root-admin-login.message": "Vous êtes connecté en tant qu'administrateur en lecture seule. Por accéder à la console Web Recovery veuillez vous identifier en tant qu'utilisateur du tenant client ou administrateur.",
    "error.server-busy.message": "Le serveur est occupé ; veuillez réessayer ultérieurement.",
    "error.network-connection.title": "Erreur de connexion réseau",
    "error.network-connection.message": "Vérifiez votre connexion Internet et réessayez.",
    "error.internal-server-error.title": "Erreur interne du serveur",
    "error.internal-server-error.message": "Pour résoudre l'erreur, contactez l'assistance et fournissez-lui les détails d'erreur suivants :",
    "error.internal-server-error.copy.button": "Copier"
};
